function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConcert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.378418,
    width: 52,
    height: 52,
    rx: 6,
    fill: "#CA0C64",
    fillOpacity: 0.08,
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 0.08
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2677 19.9392L36.2165 18.0492V18.0491C34.6667 15.6252 32.3635 13.7776 29.6612 12.7906C26.9587 11.8037 24.0068 11.7319 21.2597 12.5866C18.5124 13.4412 16.1223 15.1747 14.4565 17.5205C12.7909 19.8664 11.9421 22.6944 12.041 25.5699C12.1398 28.4451 13.1806 31.2082 15.0032 33.4344C16.8259 35.6603 19.3294 37.2257 22.1291 37.89L22.934 34.4818C20.8805 33.9952 19.0439 32.847 17.7066 31.2141C16.3695 29.5813 15.6062 27.554 15.5341 25.4448C15.4621 23.3356 16.0851 21.2612 17.3077 19.5407C18.5302 17.8202 20.2842 16.5494 22.2996 15.9238C24.3152 15.298 26.4807 15.352 28.4626 16.0774C30.4444 16.803 32.1329 18.1598 33.2678 19.9391L33.2677 19.9392Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0312 25.9943V29.4944H31.2812C29.8888 29.4944 28.5535 30.0475 27.5689 31.032C26.5844 32.0167 26.0312 33.352 26.0312 34.7443C26.0312 36.1365 26.5844 37.4719 27.5689 38.4565C28.5536 39.441 29.8889 39.9942 31.2812 39.9942C32.6734 39.9942 34.0088 39.441 34.9934 38.4565C35.9779 37.4718 36.5311 36.1365 36.5311 34.7443V25.9942H40.0311V22.4941H36.5311C35.6028 22.4941 34.7125 22.8628 34.0561 23.5192C33.3997 24.1757 33.031 25.0659 33.031 25.9942L33.0312 25.9943ZM33.0312 34.7444C33.0312 35.2085 32.8467 35.6536 32.5186 35.9818C32.1903 36.31 31.7453 36.4944 31.2812 36.4944C30.817 36.4944 30.3719 36.31 30.0437 35.9818C29.7156 35.6536 29.5311 35.2085 29.5311 34.7444C29.5311 34.2803 29.7156 33.8352 30.0437 33.507C30.372 33.1788 30.817 32.9944 31.2812 32.9944H33.0312V34.7444Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7813 25.1192C27.7813 26.569 26.6061 27.7442 25.1563 27.7442C23.7065 27.7442 22.5312 26.569 22.5312 25.1192C22.5312 23.6693 23.7065 22.4941 25.1563 22.4941C26.6061 22.4941 27.7813 23.6693 27.7813 25.1192Z",
    fill: "#CA0C64",
    style: {
      fill: "#CA0C64",
      fill: "color(display-p3 0.7922 0.0471 0.3922)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcert);
export default __webpack_public_path__ + "static/media/concert.ac8b5b63d9ffb3a85127bcf91b963de4.svg";
export { ForwardRef as ReactComponent };